import { render, staticRenderFns } from "./Video-Columns.vue?vue&type=template&id=0a6e1a27"
import script from "./Video-Columns.vue?vue&type=script&lang=js"
export * from "./Video-Columns.vue?vue&type=script&lang=js"
import style0 from "./Video-Columns.vue?vue&type=style&index=0&id=0a6e1a27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports